<template>
  <b-form @submit.prevent="submit" class="page">
    <header-page-layout
      :page-title="title"
      :back-to="{ name: 'campaigns-index' }"
      back-text="Campaigns"
    >
      <template slot="actions">
        <b-button variant="outline-primary" type="submit">Save</b-button>
      </template>

      <b-nav>
        <b-nav-item exact v-if="$route.params.id" :to="{ name: 'campaigns-edit', params: { id: $route.params.id }, query: $route.query }">
          Activity
        </b-nav-item>

        <b-nav-item v-if="!$route.params.id" :to="{ name: 'campaigns-create' }">
          Details
        </b-nav-item>

        <b-nav-item v-if="$route.params.id" :to="{ name: 'campaigns-details', params: { id: $route.params.id }}">
          Details
        </b-nav-item>

        <b-nav-item v-if="$route.params.id" :to="{ name: 'campaigns-stages', params: { id: $route.params.id }}">
          Stages
        </b-nav-item>

<!--        <b-nav-item v-if="$route.params.id" :to="{ name: 'campaigns-queue', params: { id: $route.params.id }}">
          Mail Queue
        </b-nav-item>-->

        <b-nav-item v-if="$route.params.id" :to="{ name: 'campaigns-actions', params: { id: $route.params.id }}">
          Actions
        </b-nav-item>
      </b-nav>

      <campaign-stats class="mt-3"></campaign-stats>

      <router-view></router-view>
    </header-page-layout>
  </b-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HeaderPageLayout from '../components/HeaderPageLayout'
import CampaignStats from '../components/CampaignStats'
import store from '../store'

export default {
  components: {
    HeaderPageLayout,
    CampaignStats
  },

  beforeRouteEnter(to, from, next) {
    if ('id' in to.params) {
      store.dispatch('campaigns/fetchOne', to.params.id)
        .then(() => next())
    } else {
      store.dispatch('campaigns/newCampaign')
        .then(() => next())
    }
  },

  computed: {
    ...mapState('campaigns', [
      'campaign'
    ]),

    title() {
      return this.campaign && this.campaign._id ? this.campaign.name : 'Creating Campaign'
    }
  },

  methods: {
    ...mapActions('campaigns', [
      'fetchOne',
      'saveCampaign'
    ]),

    submit() {
      this.saveCampaign().then(res => {
        if (this.$router.currentRoute.name === 'campaigns-create') {
          this.$router.push({ name: 'campaigns-edit', params: { id: res._id } })
        } else {
          this.$router.push({ name: 'campaigns-index' })
        }
      })
    }
  }
}
</script>

<style scoped>
 .section-header {
   background-color: transparent;
 }
</style>
